import { App } from '../types/App'
import { DEFAULT_LOCALE, DEFAULT_REGION } from '@/app/i18n'

const preferredOrg = (preventDefault?: boolean): App['preferredOrganization'] => {
  const {
    locale = preventDefault ? undefined : DEFAULT_LOCALE,
    region = preventDefault ? undefined : DEFAULT_REGION,
    ...preferredOrg
  } = (window?.App?.preferredOrganization || {}) as App['preferredOrganization']

  return { ...preferredOrg, locale, region }
}

export default preferredOrg
